import React from 'react';

import { Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';

class NPHelpButton extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        }
    }

    render() {
        const { title, content } = this.props;
        const { showModal } = this.state;

        return (
            <div>
                <FontAwesome className="handy" name="question-circle" onClick={() => { this.setState({ showModal: true })}} />

                <Modal show={showModal} onHide={() => { this.setState({ showModal: false }) }}>
                    <Modal.Header closeButton> 
                        <Modal.Title>{title}</Modal.Title>
                    </Modal.Header>
                    
                    <Modal.Body>
                        {content}
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}

export default NPHelpButton;